import { DMImage } from '@/components/custom-image/custom-image';
import { DMLink } from '@/components/link';
import { ALL_BADGE, cn } from '@/lib/utils';

type HeaderProps = {
  miniTitle?: string;
  description?: string;
  className?: string;
  color?: string;
  showBadges?: boolean;
  link?: {
    title: string;
    href: string;
  };
} & (
  | {
      title: string;
      subTitle?: string;
    }
  | {
      title?: string;
      subTitle: string;
    }
);

export const MainHeader = ({
  miniTitle,
  title,
  subTitle,
  description,
  className,
  color,
  showBadges = false,
  link = { title: '', href: '' },
}: HeaderProps) => {
  return (
    <div className={cn('text-center mb-10 sm:mb-16', className)}>
      {miniTitle && (
        <span className='text-xs' style={{ color }}>
          {miniTitle}
        </span>
      )}

      {title ? (
        <h2 className='my-4 mb-[20px] sm:mb-[35px]'>{title}</h2>
      ) : (
        <h3 className='my-4 mb-[25px]'>{subTitle}</h3>
      )}

      {description && <p className='description max-w-[800px] mx-auto'>{description}</p>}

      {link?.href && (
        <div className='mt-4'>
          <DMLink href={link.href} className='text-brand-primary underline'>
            {link.title}
          </DMLink>
        </div>
      )}
      {showBadges && (
        <div className='flex items-center justify-center gap-6 text-center max-w-[400px] mx-auto mt-4'>
          {ALL_BADGE.map(badge => (
            <div
              key={badge.id}
              className='bg-brand-secondary rounded-sm p-2 border border-brand-primary-border'
            >
              <DMImage
                src={badge.icon}
                width={80}
                height={80}
                alt={badge.name}
                className='m-auto'
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
